import api from "api";
import * as constants from "./actionTypes";

export const getGlobalPresence = () => {
	return async (dispatch) => {
		(async () => {
			try {
				// TODO: Replace all uses with api-v1 or v2
				const globalPresence = await api.get("global-presence").json();
				await dispatch({
					type: constants.GET_GLOBAL_PRESENCE,
					payload: globalPresence,
				});
			} catch (e) {
				console.log(e);
			}
		})();
	};
};
